import { CreditCardController } from './useCase/CreditCardController'

export const creditCardService = ({ ...props }) => CreditCardController.handle(props)
